import { NodeSpec } from 'prosemirror-model'

// changed from prosemirror-schema-list

interface ListAttrs {
  type: string
  start?: number
}

interface ListItemAttrs {
  checked: boolean | null
}

export const list: NodeSpec = {
  attrs: {
    type: { default: 'ordered' }, // 'ordered', 'bullet', 'simple', 'checklist'
    start: { default: 1 }, // for ordered lists
  },
  group: 'block list',
  content: 'listItem+',
  enforceItemType: "listItem",
  isList: true,
  dragHandleOnRow: true,
  definingAsContext: true,
  parseDOM: [
    {
      tag: 'ol',
      getAttrs: (dom: HTMLElement): ListAttrs => {
        const element = dom as HTMLOListElement;
        const start = element.getAttribute('start')

        return {
          type: 'ordered',
          start: start === null ? 1 : Number(start),
        }
      },
    },
    { tag: 'ul.simple', getAttrs: () => ({ type: 'simple' }) },
    { tag: 'ul.checklist', getAttrs: () => ({ type: 'checklist' }) },
    { tag: 'ul[data-type="checklist"]', getAttrs: () => ({ type: 'checklist' }) },
    { tag: 'ul', getAttrs: () => ({ type: 'bullet' }) },
  ],
  toDOM: (node) => {
    const { type, start } = node.attrs as ListAttrs

    switch (type) {
      case 'ordered':
        return ['ol', { start: start === 1 ? undefined : String(start) }, 0]

      case 'simple':
        return ['ul', { class: 'simple' }, 0]
      case 'checklist':
        return ['ul', { class: 'checklist', 'data-type': 'checklist' }, 0]
      case 'bullet':
      default:
        return ['ul', 0]
    }
  },
}

export const listItem: NodeSpec = {
  attrs: {
    checked: { default: null },
  },
  content: '(block|list)+',
  dragHandle: true,
  defining: true,
  isListItem: true,
  dragHandleOnRow: true,
  definingAsContext: true,
  parseDOM: [
    {
      tag: 'li[data-checked]',
      getAttrs: (element) => {
        const checkedAttr = element.getAttribute('data-checked')

        return {
          checked:
            checkedAttr === 'true'
              ? true
              : checkedAttr === 'false'
                ? false
                : null,
        }
      },
      contentElement: '[data-checkbox-content]',
    },
    {
      tag: 'li',
      getAttrs: (element) => {
        const checkbox = element.querySelector('input[type="checkbox"], [data-checkbox]')
        if (!checkbox) {
          return {
            checked: null,
          }
        }

        const isChecked = checkbox instanceof HTMLInputElement ? checkbox.checked : checkbox.getAttribute('aria-checked') === 'true'
        checkbox.remove()

        return {
          checked: isChecked,
        }
      },
    },
  ],
  toDOM: (node) => {
    const { checked } = node.attrs as ListItemAttrs
    if (checked === true || checked === false) {
      return [
        'li',
        {
          'data-list-item': 'true',
          'data-checked': checked ? 'true' : 'false',
        },
        ['span', {
          'data-checkbox': 'true',
          role: 'checkbox',
          'aria-checked': checked ? 'true' : 'false',
          contenteditable: 'false',
          tabindex: '0',
        }],
        ['div', { 'data-checkbox-content': 'true' }, 0],
      ]
    }

    return ['li', { 'data-list-item': 'true' }, 0]
  },
}
